<template>
  <div
    class="loader"
    :class="size ? `loader-${size}` : ''">
    <div
      class="loading-circle"
      :class="[color ? color : '']"
      :style="cssVars">
      <div class="fixed-circle"/>
      <div class="rotating-section"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// TODO make special class for inline spinner (width: fit-content or something like that)

// TODO refactor to always be small and it can be set as bigger from the parent

.loader {
  position: relative;
  width: 100%;
  height: 24px;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  opacity: 1;
  overflow: hidden;

  &.small {
    margin: 0;
  }

  * {
    animation-play-state: running;
  }

  .loading-circle {
    margin: 0 auto 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: relative;
    animation: loader-spin .7s infinite linear;

    .fixed-circle {
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border-width: var(--thickness);
      border-style: solid;
      border-color: var(--color);
      opacity: 0.2;
    }

    .rotating-section {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: block;
      position: absolute;
      left: 0px;
      top: 0px;
      border: 3px solid transparent;
      border-width: var(--thickness);
      border-style: solid;
      border-top-color: var(--color);
      opacity: 0.7;
    }
  }
}

// Loader class with different sizes ranging from 5 to 50px in diameter
@for $i from 10 through 30 {
  $loaderSize: $i;

  .loader-#{$loaderSize} {
    height: #{$loaderSize}px;
    &.small {
      width: #{$loaderSize}px;
    }

    .loading-circle {
      width: #{$loaderSize}px;
      height: #{$loaderSize}px;

      .fixed-circle {
        width: #{$loaderSize}px;
        height: #{$loaderSize}px;
      }

      .rotating-section {
        width: #{$loaderSize}px;
        height: #{$loaderSize}px;
      }
    }
  }
}

@keyframes loader-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#141c20',
    },
    thickness: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  computed: {
    cssVars() {
      return {
        '--thickness': `${this.thickness}px`,
        '--color': this.color,
      };
    },
  },
};
</script>
